import { TaskState } from '@src/editor-helpers'
import { Map } from 'immutable'
import { EditorState, ContentState, ContentBlock } from 'draft-js'

export default (editorState: EditorState) => {
  const contentState = editorState.getCurrentContent()
  const blockWithEmptyData = contentState.getBlockMap().find(block => block && block.get('data').isEmpty())
  if (blockWithEmptyData) {
    let blockWithData
    const blockTypeWithEmptyData = blockWithEmptyData.get('type')

    if (blockTypeWithEmptyData === 'decision') {
      blockWithData = blockWithEmptyData.merge({
        type: 'unstyled'
      }) as ContentBlock
      let newContentState = contentState.merge({
        blockMap: contentState.getBlockMap().set(blockWithEmptyData.getKey(), blockWithData)
      }) as ContentState
      editorState = EditorState.push(editorState, newContentState, 'change-block-type')

      blockWithData = blockWithData.merge({
        data: Map({ type: 'solution' })
      }) as ContentBlock
      newContentState = newContentState.merge({
        blockMap: contentState.getBlockMap().set(blockWithEmptyData.getKey(), blockWithData)
      }) as ContentState
      editorState = EditorState.push(editorState, newContentState, 'change-block-data')
    } else {
      editorState = EditorState.set(editorState, { allowUndo: false })

      const blockBeforeEmpty = contentState.getKeyBefore(blockWithEmptyData.get('key'))
      const taskState = TaskState.fromEditorState(editorState)
      const task = TaskState.getTaskByKey(taskState, blockBeforeEmpty)
      let blockType = TaskState.getBlockTaskType(task, blockBeforeEmpty)

      blockType = blockType === 'solution' ? 'conspect' : blockType
      blockWithData = blockWithEmptyData.merge({
        data: Map({ type: blockType })
      }) as ContentBlock

      const newContentState = contentState.merge({
        blockMap: contentState.getBlockMap().set(blockWithEmptyData.getKey(), blockWithData)
      }) as ContentState
      editorState = EditorState.push(editorState, newContentState, 'change-block-data')
      editorState = EditorState.set(editorState, { allowUndo: true })
    }
  }
  return editorState
}



// WEBPACK FOOTER //
// ./src/editor-helpers/EditorStateOps/addTypeToNewBlock.ts